// Evidence about this device's REAL location-permission situation, kept in
// localStorage — needed because WebKit (iPhone/iPad Safari) reports the
// Permissions API as "prompt" after every reload even when the per-site
// setting is Allow: it only reveals "granted" once location is used that
// visit (privacy: sites shouldn't learn they're pre-trusted before use).
//
// The tell we CAN observe: when a request starts at "prompt" and flips to
// "granted" in under a second, no human tapped a popup — that's the saved
// per-site Allow. A slower flip means a real popup was answered. The flag
// self-heals: a slow flip or a denial clears it.

const SILENT_KEY = 'chariot.geoSilentGrant';
const LAST_OK_KEY = 'chariot.geoLastOkAt';

const store = (k, v) => { try { localStorage.setItem(k, v); } catch { /* unavailable */ } };
const read = (k) => { try { return localStorage.getItem(k); } catch { return null; } };

export const hasSilentGrant = () => read(SILENT_KEY) === '1';
export const lastGeoOkAt = () => Number(read(LAST_OK_KEY)) || null;
export const recordGeoSuccess = () => store(LAST_OK_KEY, String(Date.now()));
export const clearSilentGrant = () => store(SILENT_KEY, '0');

// Call right before a getCurrentPosition attempt. Watches the permission
// state: a prompt→granted flip in <1s = the saved Allow (no popup possible
// that fast); ≥1s = a human answered a popup. Returns a cleanup to call once
// the attempt settles (harmless to call twice).
export function beginGrantTiming() {
  if (!navigator.permissions?.query) return () => {};
  let status = null;
  let finished = false;
  const t0 = performance.now();
  const cleanup = () => {
    finished = true;
    if (status) status.onchange = null;
  };
  navigator.permissions.query({ name: 'geolocation' })
    .then((st) => {
      if (finished || st.state !== 'prompt') return; // already known — nothing to learn
      status = st;
      st.onchange = () => {
        if (st.state === 'granted') {
          store(SILENT_KEY, performance.now() - t0 < 1000 ? '1' : '0');
        } else if (st.state === 'denied') {
          store(SILENT_KEY, '0');
        }
        cleanup();
      };
    })
    .catch(() => {});
  return cleanup;
}
